'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Instagram } from 'lucide-react';
import { getHeroBackgroundImage } from '@/utils/imageSettings';
import styles from './not-found.module.css';

export default function NotFound() {
  const [heroBackgroundImg, setHeroBackgroundImg] = useState('');

  useEffect(() => {
    const loadImage = async () => {
      try {
        const bgImg = await getHeroBackgroundImage();
        setHeroBackgroundImg(bgImg);
      } catch (error) {
        console.error('Error loading background image:', error);
      }
    };
    loadImage();
  }, []);

  return (
    <div className={styles.notFoundPage}>
      <div className={styles.background}>
        {heroBackgroundImg && (
          <Image
            src={heroBackgroundImg}
            alt="Background"
            fill
            priority
            quality={90}
            style={{ objectFit: 'cover' }}
          />
        )}
        <div className={styles.overlay}></div>
      </div>

      <div className={styles.content}>
        <div className={styles.logoWrapper}>
          <Image 
            src="/LM_W_1024.png"
            alt="Lior Murphy"
            width={200}
            height={100}
            priority
            style={{ width: 'auto', height: 'auto' }}
          />
        </div>

        <h1 className={styles.title}>404</h1>
        <h2 className={styles.subtitle}>This page isn&apos;t here</h2>
        <p className={styles.description}>
          Head home, or start from the live Zoom classes for backbends and
          splits.
        </p>

        <div className={styles.actions}>
          <Link href="/" className={styles.btnPrimary}>
            Back to Home
          </Link>
          <Link href="/classes" className={styles.btnSecondary}>
            Live Classes
          </Link>
          <a
            href="https://www.instagram.com/lior_murphy"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.btnSecondary}
          >
            <Instagram size={20} />
            Follow on Instagram
          </a>
        </div>
      </div>
    </div>
  );
}

